/** Closed-state placeholder tone for `<select class="al-sel">` when `value` is empty. */
export function alSelClass(value: string): string {
  return value === '' ? 'al-sel al-sel-ph' : 'al-sel';
}

/** Filter bar selects (`flt-sel`): empty, `All`, or `All …` sentinel values use placeholder tone. */
export function fltSelClass(value: string): string {
  const ph = value === '' || value === 'All' || value.startsWith('All ');
  return ph ? 'flt-sel flt-sel-ph' : 'flt-sel';
}
